exports = module.exports = require("../../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TUASos2bupC9FfTrIUow-{-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}._2_iFo1rvwFvxNXTd_UMxCJ input{text-align:center;letter-spacing:1rem}._2XHYMlMKOtwlF7oj4Woo2I div{border-color:#ff6562}._2M9LSYu7rPIH6FPEnlqWUP{color:red;text-align:center;margin-top:-1rem;font-size:.8rem}\n", ""]);

// exports
exports.locals = {
	"wrapper": "TUASos2bupC9FfTrIUow-",
	"tokenInputWrapper": "_2_iFo1rvwFvxNXTd_UMxCJ",
	"withErrorBorder": "_2XHYMlMKOtwlF7oj4Woo2I",
	"tokenErrorMessage": "_2M9LSYu7rPIH6FPEnlqWUP"
};